// Created by hejikun on 2017/11/2 0002.
let registration = [
  {
    path: '/PCregistration_hospital_detail',
    name: '医院详情',
    component: () => import('@/pages/registration/PCregistration_hospital_detail')
  },
  {
    path: '/PCregistration_hospital_detail_new',
    name: '医院详情',
    component: () => import('@/pages/registration/registration_hospital_detail_new')
  },
  {
    path: '/PCregistration_detail',
    name: '医院简介',
    component: () => import('@/pages/registration/PCregistration_detail')
  },
  {
    path: '/PCregistration_depart_list',
    name: '科室列表',
    component: () => import('@/pages/registration/PCregistration_depart_list')
  },
  {
    path: '/PCregistration_doctor_list',
    name: '医生列表',
    component: () => import('@/pages/registration/PCregistration_doctor_list')
  },
  {
    path: '/registration_doctor_list_new',
    name: '医生列表',
    component: () => import('@/pages/registration/registration_doctor_list_new')
  },
  {
    path: '/PCregistration_doctor_detail',
    name: '医生详情',
    component: () => import('@/pages/registration/PCregistration_doctor_detail')
  },
  {
    path: '/registration_doctor_detail_new',
    name: '医生详情',
    component: () => import('@/pages/registration/registration_doctor_detail_new')
  },
  {
    path: '/registration_doctor_detail_v3',
    name: '专病专诊医生详情',
    component: () => import('@/pages/registration/registration_doctor_detail_v3')
  },
  {
    path: '/registration_doctor_detail_redirect',
    name: '医生详情重定向',
    component: () => import('@/pages/registration/registration_doctor_detail_redirect')
  },
  {
    path: '/registration',
    name: '预约挂号',
    component: () => import('@/pages/registration/index')
  },
  {
    path: '/registration_fast_appointment',
    name: '快速挂号',
    component: () => import('@/pages/fastRegistration/index')
  },
  {
    path: '/registration_hospital_list_old',
    name: '医院列表',
    component: () => import('@/pages/registration/registration_hospital_list')
  },
  {
    path: '/registration_hospital_list',
    name: '医院列表',
    component: () => import('@/pages/registration/registration_hospital_list1')
  },
  {
    path: '/registration_hospital_list_new',
    name: '医院列表',
    component: () => import('@/pages/registration/registration_hospital_list_new')
  },
  {
    path: '/registration_depart_grade_list',
    name: '科室列表',
    component: () => import('@/pages/registration/registration_depart_grade_list')
  },
  {
    path: '/registration_yunda_dep_list',
    name: '科室列表',
    component: () => import('@/pages/registration/registration_yunda_dep_list')
  },
  {
    path: '/registration_yunda_new_dep',
    name: '科室列表',
    component: () => import('@/pages/registration/registration_yunda_new_dep')
  },
  {
    path: '/registration_hospital_detail',
    name: '医院详情',
    component: () => import('@/pages/registration/registration_hospital_detail')
  },
  {
    path: '/yundaDep',
    name: '科室介绍',
    component: () => import('@/pages/registration/yundaDep')
  },
  {
    path: '/department_introduction',
    name: '介绍详情',
    component: () => import('@/pages/registration/department_introduction')
  },
  {
    path: '/registration_depart_list',
    name: '科室列表',
    component: () => import('@/pages/registration/registration_depart_list')
  },
  {
    path: '/registration_yunda_list',
    name: '科室列表',
    component: () => import('@/pages/registration/registration_yunda_list')
  },
  {
    path: '/registration_doctor_list',
    name: '医生列表',
    component: () => import('@/pages/registration/registration_doctor_list')
  },
  {
    path: '/registration_doctor_detail',
    name: '医生详情',
    component: () => import('@/pages/registration/registration_doctor_detail')
  },
  {
    path: '/registration_order_confirm',
    name: '预约信息确认',
    component: () => import('@/pages/registration/registration_order_confirm')
  },
  {
    path: '/registration_order_confirm_new',
    name: '预约挂号',
    component: () => import('@/pages/registration/registration_order_confirm_new')
  },
  {
    path: '/registration_order_confirm_new_saTcm',
    name: '预约挂号',
    component: () => import('@/pages/registration/registration_order_confirm_new_saTcm')
  },
  {
    path: '/registration_strategy_list',
    name: '就医攻略列表',
    component: () => import('@/pages/registration/registration_strategy_list')
  },
  {
    path: '/registration_strategy_detail',
    name: '就医攻略详情',
    component: () => import('@/pages/registration/registration_strategy_detail')
  },
  {
    path: '/registration_strategy_post',
    name: '就医攻略发帖',
    component: () => import('@/pages/registration/registration_strategy_post')
  },
  {
    path: '/registration_strategy_reply',
    name: '就医攻略回复',
    component: () => import('@/pages/registration/registration_strategy_reply')
  },
  {
    path: '/registration_strategy_report',
    name: '就医攻略举报',
    component: () => import('@/pages/registration/registration_strategy_report')
  },
  {
    path: '/registration_online_payment_old',
    name: '在线缴费',
    component: () => import('@/pages/registration/registration_online_payment')
  },
  {
    path: '/registration_online_payment',
    name: '在线缴费',
    component: () => import('@/pages/registration/registration_online_payment_new')
  },
  {
    path: '/registration_online_payment_v3',
    name: '在线缴费',
    component: () => import('@/pages/registration/registration_online_payment_v3')
  },
  {
    path: '/registration_online_payment_record_pay_v3',
    name: '在线缴费',
    component: () => import('@/pages/registration/registration_online_payment_record_pay_v3')
  },
  {
    path: '/registration_online_payment_records',
    name: '在线缴费列表',
    component: () => import('@/pages/registration/registration_online_payment_records')
  },
  {
    path: '/registration_online_payment_record_pay',
    name: '在线缴费详情',
    component: () => import('@/pages/registration/registration_online_payment_record_pay')
  },
  {
    path: '/registration_report',
    name: '检验检查报告',
    component: () => import('@/pages/registration/registration_report')
  },
  {
    path: '/registration_report_v3',
    name: '检验检查报告',
    component: () => import('@/pages/registration/registration_report_v3')
  },
  {
    path: '/registration_report_list',
    name: '检验检查报告列表',
    component: () => import('@/pages/registration/registration_report_list')
  },
  {
    path: '/registration_report_list_v3',
    name: '检验检查报告列表',
    component: () => import('@/pages/registration/registration_report_list_v3')
  },
  {
    path: '/registration_report_pdf',
    name: '检验检查报告pdf',
    component: () => import('@/pages/registration/registration_report_pdf')
  },
  {
    path: '/registration_report_detail',
    name: '检验检查报告详情',
    component: () => import('@/pages/registration/registration_report_detail')
  },
  {
    path: '/registration_report_detail_v3',
    name: '检验检查报告详情',
    component: () => import('@/pages/registration/registration_report_detail_v3')
  },
  {
    path: '/registration_floor_open',
    name: '楼层分布',
    component: () => import('@/pages/registration/registration_floor_open')
  },
  {
    path: '/registration_stop',
    name: '停诊通知',
    component: () => import('@/pages/registration/registration_stop')
  },
  {
    path: '/registration_rule',
    name: '预约规则',
    component: () => import('@/pages/registration/registration_rule')
  },
  {
    path: '/registration_rule_new',
    name: '预约规则',
    component: () => import('@/pages/registration/registration_rule_new')
  },
  {
    path: '/registration_detail',
    name: '医院简介',
    component: () => import('@/pages/registration/registration_detail')
  },
  {
    path: '/registration_detail_new',
    name: '医院简介',
    component: () => import('@/pages/registration/registration_detail_new')
  },
  {
    path: '/registration_treat_wait',
    name: '候诊查询',
    component: () => import('@/pages/registration/registration_treat_wait')
  },
  {
    path: '/registration_treat_wait_detail',
    name: '候诊详情',
    component: () => import('@/pages/registration/registration_treat_wait_detail')
  },
  {
    path: '/registration_guide',
    name: '取号指南',
    component: () => import('@/pages/registration/registration_guide')
  },
  {
    path: '/strategy',
    name: '就医攻略',
    component: () => import('@/pages/registration/strategy/strategy')
  },
  {
    path: '/more_invitation',
    name: '更多攻略',
    component: () => import('@/pages/registration/strategy/more_invitation')
  },
  {
    path: '/invitation_detail',
    name: '攻略详情',
    component: () => import('@/pages/registration/strategy/invitation_detail')
  },
  {
    path: '/revert',
    name: '攻略回复',
    component: () => import('@/pages/registration/strategy/revert')
  },
  {
    path: '/report',
    name: '举报',
    component: () => import('@/pages/registration/strategy/report')
  },
  {
    path: '/registration_vaccine_home',
    // path: '/registration_vaccine_list',
    name: '疫苗医院列表',
    component: () => import('@/pages/registration/registration_vaccine_list1')
  },
  {
    path: '/registration_vaccine_list',
    // path: '/registration_vaccine_list_new',
    name: '疫苗预约',
    component: () => import('@/pages/registration/registration_vaccine_list')
    // component: () => import('@/pages/registration/registration_vaccine_list_new')
  },
  {
    // path: '/registration_vaccine_search',
    path: '/registration_vaccine_search',
    name: '疫苗预约',
    component: () => import('@/pages/registration/registration_vaccine_search')
  },
  {
    path: '/registration_vaccine_agency',
    name: '接种机构',
    component: () => import('@/pages/registration/registration_vaccine_agency')
  },
  {
    path: '/registration_vaccine_adress',
    name: '接种地点',
    component: () => import('@/pages/registration/registration_vaccine_adress')
  },
  {
    path: '/register_aier',
    name: '青少年近视防控',
    component: () => import('@/pages/registration/register_aier')
  },
  {
    path: '/register_kunhua_depart_list',
    name: '科室列表',
    component: () => import('@/pages/registration/register_kunhua_depart_list')
  },
  {
    path: '/register_fuwai_depart_list',
    name: '科室列表',
    component: () => import('@/pages/registration/register_fuwai_depart_list')
  },
  {
    path: '/register_gongren_depart_list',
    name: '科室列表',
    component: () => import('@/pages/registration/register_gongren_depart_list')
  },

  {
    path: '/registration_depart_list_new',
    name: '科室列表',
    component: () => import('@/pages/registration/registration_depart_list_new')
  },
  {
    path: '/registration_yunda_depart_list_v3',
    name: '科室列表',
    component: () => import('@/pages/registration/registration_yunda_depart_list_v3')
  },
  {
    path: '/registration_doctor_list_new_sa_tcm',
    name: '科室列表',
    component: () => import('@/pages/registration/registration_doctor_list_new_sa_tcm')
  },
  {
    path: '/register_yanan_dep_list',
    name: '科室列表',
    component: () => import('@/pages/registration/register_yanan_dep_list')
  },
  {
    path: '/register_shenfy_depart_list',
    name: '科室列表',
    component: () => import('@/pages/registration/register_shenfy_depart_list')
  },
  {
    path: '/registration_chronic_old',
    name: '风湿免疫科',
    component: () => import('@/pages/registration/registration_chronic')
  },
  {
    path: '/registration_chronic',
    name: '风湿免疫科',
    component: () => import('@/pages/registration/registration_chronic')
  },
  {
    path: '/registration_chronic_new',
    name: '风湿免疫科',
    component: () => import('@/pages/registration/registration_chronic_new')
  },
  {
    path: '/registration_chronic_doclist',
    name: '医生列表',
    component: () => import('@/pages/registration/registration_chronic_doclist')
  },
  {
    path: '/registration_no_smoking',
    name: '戒烟门诊医生列表',
    component: () => import('@/pages/registration/registration_no_smoking')
  },
  {
    path: '/registration_heart_doclist',
    name: '心率失常专科-医生列表',
    component: () => import('@/pages/registration/registration_heart_doclist')
  },
  {
    path: '/registration_cancer',
    name: '肿瘤基因筛查',
    component: () => import('@/pages/registration/registration_cancer')
  },
  {
    path: '/registration_no_drinking',
    name: '戒酒门诊',
    component: () => import('@/pages/registration/registration_no_drinking')
  },
  {
    path: '/registration_no_drinking_detail',
    name: '戒酒门诊',
    component: () => import('@/pages/registration/registration_no_drinking_detail')
  },
  {
    path: '/register_mdt',
    name: '特需门诊',
    component: () => import('@/pages/registration/register_mdt')
  },
  {
    path: '/register_mdt_new',
    name: '特需门诊',
    component: () => import('@/pages/registration/register_mdt_new')
  },
  {
    path: '/registration_women_health',
    name: '妇科健康',
    component: () => import('@/pages/registration/registration_women_health')
  },
  {
    path: '/registration_women_health_new',
    name: '妇科健康',
    component: () => import('@/pages/registration/registration_women_health_new')
  },
  {
    path: '/registration_grow_tall',
    name: '增高门诊',
    component: () => import('@/pages/registration/registration_grow_tall')
  },
  {
    path: '/registration_grow_tall_detail',
    name: '增高门诊',
    component: () => import('@/pages/registration/registration_grow_tall_detail')
  },
  {
    path: '/registration_grow_tall_excel_detail',
    name: '增高门诊',
    component: () => import('@/pages/registration/registration_grow_tall_excel_detail')
  },
  {
    path: '/registration_nucleic_testing',
    name: '核酸检查',
    component: () => import('@/pages/registration/registration_nucleic_testing')
  },
  {
    path: '/registration_merge_pay',
    name: '合并缴费',
    component: () => import('@/pages/registration/registration_merge_pay')
  },
  {
    path: '/registration_cancer_list',
    name: '检测申请列表',
    component: () => import('@/pages/registration/registration_cancer_list')
  },
  {
    path: '/registration_cancer_apply',
    name: '检测申请单',
    component: () => import('@/pages/registration/registration_cancer_apply')
  },
  {
    path: '/registration_cancer_accept',
    name: '知情同意书',
    component: () => import('@/pages/registration/registration_cancer_accept')
  },
  {
    path: '/registration_cancer_patientInfo1',
    name: '受检人信息',
    component: () => import('@/pages/registration/registration_cancer_patientInfo1')
  },
  {
    path: '/registration_cancer_patientInfo2',
    name: '受检人信息',
    component: () => import('@/pages/registration/registration_cancer_patientInfo2')
  },
  {
    path: '/registration_cancer_sampleInfo',
    name: '受检人信息',
    component: () => import('@/pages/registration/registration_cancer_sampleInfo')
  },
  {
    path: '/registration_cancer_type',
    name: '肿瘤类型',
    component: () => import('@/pages/registration/registration_cancer_type')
  },
  {
    path: '/registration_cancer_content',
    name: '检测内容',
    component: () => import('@/pages/registration/registration_cancer_content')
  },
  {
    path: '/registration_cancer_order_list',
    name: '肿瘤筛查订单列表',
    component: () => import('@/pages/registration/registration_cancer_order_list')
  },
  {
    path: '/registration_cancer_order_detail',
    name: '肿瘤筛查订单详情',
    component: () => import('@/pages/registration/registration_cancer_order_detail')
  },
  {
    path: '/registration_sign_in',
    name: '排队签到',
    component: () => import('@/pages/registration/registration_sign_in')
  },
  {
    path: '/registration_cloudfilm_sign_in',
    name: '云胶片',
    component: () => import('@/pages/registration/registration_cloudfilm_sign_in')
  },
  {
    path: '/registration_sign_list',
    name: '排队签到',
    component: () => import('@/pages/registration/registration_sign_list')
  },
  {
    path: '/registration_sign_list_new',
    name: '排队签到',
    component: () => import('@/pages/registration/registration_sign_list_new')
  },
  {
    path: '/registration_examine_list',
    name: '检查预约',
    component: () => import('@/pages/registration/registration_examine_list')
  },
  {
    path: '/registration_examine_detail',
    name: '检查预约',
    component: () => import('@/pages/registration/registration_examine_detail')
  },
  {
    path: '/registration_examine_order_detail',
    name: '检查预约',
    component: () => import('@/pages/registration/registration_examine_order_detail')
  },
  {
    path: '/registration_cases_query',
    name: '病历查询',
    component: () => import('@/pages/registration/registration_cases_query')
  },
  {
    path: '/registration_cases_detail',
    name: '病历查询',
    component: () => import('@/pages/registration/registration_cases_detail')
  },
  {
    path: '/registration_xingqi_detail',
    name: '昆明星启眼科医院',
    component: () => import('@/pages/registration/registration_xingqi_detail')
  },
  {
    path: '/registration_xingqi_info',
    name: '昆明星启眼科医院',
    component: () => import('@/pages/registration/registration_xingqi_info')
  },
  {
    path: '/registration_neurology_index',
    name: '神经内科专区',
    component: () => import('@/pages/registration/registration_neurology_index')
  },
  {
    path: '/registration_neurology_area',
    name: '神经内科专区',
    component: () => import('@/pages/registration/registration_neurology_area')
  },
  {
    path: '/registration_neurology_exam',
    name: 'AD8测试',
    component: () => import('@/pages/registration/registration_neurology_exam')
  },
  {
    path: '/registration_neurology_detail',
    name: '神经内科在线咨询',
    component: () => import('@/pages/registration/registration_neurology_detail')
  },
  {
    path: '/registration_vaccine',
    name: '新冠疫苗登记',
    component: () => import('@/pages/registration/registration_vaccine')
  },
  {
    // path: '/registration_vaccine_doctor',
    path: '/registration_vaccine_doctor_new',
    name: '医生详情',
    component: () => import('@/pages/registration/registration_vaccine_doctor_new')
  },
  {
    // path: '/registration_vaccine_doctor',
    path: '/registration_vaccine_doctor',
    name: '医生详情',
    component: () => import('@/pages/registration/registration_vaccine_doctor')
  },
  {
    path: '/registration_vaccine_order',
    name: '预约信息确认',
    component: () => import('@/pages/registration/registration_vaccine_order')
  },
  {
    path: '/registration_health_certificate',
    name: '健康证',
    component: () => import('@/pages/registration/registration_health_certificate')
  },
  {
    path: '/registration_filter_doctor',
    name: '医生列表',
    component: () => import('@/pages/registration/registration_filter_doctor')
  },
  {
    path: '/registration_words_filter',
    name: '医生列表',
    component: () => import('@/pages/registration/registration_words_filter')
  },
  {
    path: '/register_health_letter',
    name: '新冠相关流行病学调查承诺书',
    component: () => import('@/pages/registration/register_health_letter')
  },
  {
    path: '/registration_tongren_depart_list',
    name: '科室列表',
    component: () => import('@/pages/registration/registration_tongren_depart_list')
  },
  {
    path: '/tongrendepList',
    name: '科室列表',
    component: () => import('@/pages/registration/tongrendepList')
  },
  {
    path: '/registration_hospital_area',
    name: '院区选择',
    component: () => import('@/pages/registration/registration_hospital_area')
  },
  {
    path: '/registration_hospital_area_news',
    name: '院区选择',
    component: () => import('@/pages/registration/registration_hospital_area_news')
  },
  {
    path: '/register_cjrkangfu',
    name: '科室列表',
    component: () => import('@/pages/registration/register_cjrkangfu')
  },
  {
    path: '/registration_influenza',
    name: '流感检测',
    component: () => import('@/pages/registration/registration_influenza')
  },
  {
    path: '/registration_yunda_juanjing',
    name: '捐精预约',
    component: () => import('@/pages/registration/registration_yunda_juanjing')
  },
  {
    path: '/registration_teenager_confirm',
    name: '预约信息确认',
    component: () => import('@/pages/registration/registration_teenager_confirm')
  },
  {
    path: '/registration_back_records',
    name: '补缴记录',
    component: () => import('@/pages/registration/registration_back_records')
  },
  {
    path: '/registration_back_records_new',
    name: '补缴记录',
    component: () => import('@/pages/registration/registration_back_records_new')
  },
  {
    path: '/kunhuaDepLeve1',
    name: '科室列表',
    component: () => import('@/pages/registration/kunhuaDepLeve1')
  },
  {
    path: '/kunhuaDepLeve1_new',
    name: '科室列表',
    component: () => import('@/pages/registration/kunhuaDepLeve1_new')
  },
  {
    path: '/kunhuaDoctorSearch',
    name: '医生搜索',
    component: () => import('@/pages/registration/kunhuaDoctorSearch')
  },
  {
    path: '/kunhuaDoctorSearch_new',
    name: '医生搜索',
    component: () => import('@/pages/registration/kunhuaDoctorSearch_new')
  },
  {
    path: '/registration_kunhua_sign',
    name: '排队签到',
    component: () => import('@/pages/registration/registration_kunhua_sign')
  },
  {
    path: '/registration_kunhua_sign_new',
    name: '排队签到',
    component: () => import('@/pages/registration/registration_kunhua_sign_new')
  },
  {
    path: '/registration_sfy_sign_new',
    name: '扫码签到',
    component: () => import('@/pages/registration/registration_sfy_sign_new')
  },
  {
    path: '/registration_refund',
    name: '缴费退费',
    component: () => import('@/pages/registration/registration_refund')
  },
  {
    path: '/registration_search',
    name: '搜索医院',
    component: () => import('@/pages/registration/registration_search')
  },
  {
    path: '/registration_dep_search',
    name: '搜索科室医生',
    component: () => import('@/pages/registration/registration_dep_search')
  },
  {
    path: '/registration_pay_fees',
    name: '缴费',
    component: () => import('@/pages/registration/registration_pay_fees')
  },
  {
    path: '/registration_refund_list',
    name: '缴费退费',
    component: () => import('@/pages/registration/registration_refund_list')
  },
  {
    path: '/registration_refund_list_new',
    name: '缴费退费',
    component: () => import('@/pages/registration/registration_refund_list_new')
  },
  {
    path: '/registration_pay_new',
    name: '缴费',
    component: () => import('@/pages/registration/registration_pay_new')
  },
  {
    path: '/registration_pay_news',
    name: '缴费',
    component: () => import('@/pages/registration/registration_pay_news')
  },
  {
    path: '/registration_xinqi_doctor',
    name: '医生列表',
    component: () => import('@/pages/registration/registration_xinqi_doctor')
  },
  {
    path: '/registration_evening_clinic',
    name: '科室选择',
    component: () => import('@/pages/registration/registration_evening_clinic')
  },
  // 心血管内科
  {
    path: '/registration_cardiovascular',
    name: '心血管内科',
    component: () => import('@/pages/registration/registration_cardiovascular')
  },
  {
    path: '/yundaVip',
    name: '云大医院特需门诊',
    component: () => import('@/pages/registration/yundaVip/yundaVip')
  },

  {
    path: '/yundaVipDocList',
    name: '云大医院特需门诊医生列表',
    component: () => import('@/pages/registration/yundaVip/yundaVipDocList')
  },
  //选择就诊人
  {
    path: '/registration_szy_medical_technical',
    name: '医技预约改期',
    component: () => import('@/pages/registration/registration_szy_medical_technical')
  },
  // 列表页
  {
    path: '/registration_szy_medical_technical_list',
    name: '医技预约改期',
    component: () => import('@/pages/registration/registration_szy_medical_technical_list')
  },
  //修改页
  {
    path: '/registration_szy_medical_technical_choose_date',
    name: '医技预约改期',
    component: () => import('@/pages/registration/registration_szy_medical_technical_choose_date')
  }

  // {
  //   path: '/yundaVipDocDetail',
  //   name: '云大医院特需门诊医生',
  //   component: () => import('@/pages/registration/yundaVip/yundaVipDocDetail')
  // },
  // {
  //   path: '/registration_cancer_apply',
  //   name: '检测申请单',
  //   component: () => import('@/pages/registration/registration_cancer_apply')
  // },
  // {
  //   path: '/registration_cancer_accept',
  //   name: '知情同意书',
  //   component: () => import('@/pages/registration/registration_cancer_accept')
  // },
  // {
  //   path: '/registration_cancer_patientInfo1',
  //   name: '受检人信息',
  //   component: () => import('@/pages/registration/registration_cancer_patientInfo1')
  // },
  // {
  //   path: '/registration_cancer_patientInfo2',
  //   name: '受检人信息',
  //   component: () => import('@/pages/registration/registration_cancer_patientInfo2')
  // },
  // {
  //   path: '/registration_cancer_sampleInfo',
  //   name: '受检人信息',
  //   component: () => import('@/pages/registration/registration_cancer_sampleInfo')
  // },
  // {
  //   path: '/registration_cancer_type',
  //   name: '肿瘤类型',
  //   component: () => import('@/pages/registration/registration_cancer_type')
  // },
  // {
  //   path: '/registration_cancer_content',
  //   name: '检测内容',
  //   component: () => import('@/pages/registration/registration_cancer_content')
  // }

  // 特需门诊
]

export default registration
